import axios from "axios";
const list = () => {
    return axios({
        url: "api:///v1/component-types",
    });
};
const listDefault = () => {
    return axios({
        url: "api:///v1/component-types/default",
    });
};
export default {
    list,
    listDefault,
};
